import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new_summary_rise",
  "use": "icon-new_summary_rise-usage",
  "viewBox": "0 0 9.333 11.378",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.333 11.378\" id=\"icon-new_summary_rise\"><defs><style>#icon-new_summary_rise .a{fill:#f53f3f;}</style></defs><path class=\"a\" d=\"M4.667,0,9.333,6.023,6.27,5.338l-.049.021-.038.281a6.888,6.888,0,0,1-4.625,5.738A5.5,5.5,0,0,0,2.872,8.491a16.458,16.458,0,0,0,.248-3.136H3.2l-.037-.017L0,6.023Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol